import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a ceiling fan from the 2.6 m ceiling: a short downrod, a
// steel motor hub, four flat matte-black blades and a small glow-tone light
// kit beneath. The blades share the name "blades" so the looping "spin"
// animation turns them as one node about the hub's vertical axis.
const BLACK = "#2e2e30";
const STEEL = "#aab2b8";
const GLOW = "#f5e9c8";

const CEILING = 2.6;
const HUB_Y = 2.32;
const BLADE_LEN = 0.52;
const BLADE_R = 0.1 + BLADE_LEN / 2; // blade centre radius from the hub axis

export const ceilingFan = defineModel({
  id: "ceiling-fan",
  batchId: "modern",
  name: "Ceiling fan",
  tags: ["modern", "interior", "fixture", "lighting", "ceiling", "cooling", "animated"],
  summary: "A four-blade ceiling fan with a light kit and a looping spin.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    const parts: Part[] = [
      // Ceiling rose.
      { geometry: new THREE.CylinderGeometry(0.07, 0.07, 0.04, 12), color: STEEL,
        position: [0, CEILING - 0.02, 0] },
      // Short downrod.
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, CEILING - HUB_Y, 8), color: STEEL,
        position: [0, (CEILING + HUB_Y) / 2, 0] },
      // Motor hub.
      { geometry: new THREE.CylinderGeometry(0.1, 0.1, 0.1, 14), color: STEEL,
        position: [0, HUB_Y, 0] },
      // Small light kit beneath the hub.
      { geometry: new THREE.CylinderGeometry(0.06, 0.05, 0.05, 12), color: GLOW,
        position: [0, HUB_Y - 0.075, 0] },
    ];
    for (let i = 0; i < 4; i++) {
      const ang = (i * Math.PI) / 2;
      parts.push({
        geometry: new THREE.BoxGeometry(BLADE_LEN, 0.02, 0.13), color: BLACK,
        position: [Math.cos(ang) * BLADE_R, HUB_Y + 0.02, Math.sin(ang) * BLADE_R],
        rotation: [0, -ang, 0],
        name: "blades",
      });
    }
    return parts;
  },
  animations: [
    {
      id: "spin",
      label: "Spin",
      duration: 2,
      loop: true,
      tracks: [
        {
          target: "blades",
          pivot: [0, HUB_Y + 0.02, 0],
          rotation: [
            { t: 0, value: [0, 0, 0] },
            { t: 2, value: [0, -Math.PI * 2, 0] },
          ],
        },
      ],
    },
  ],
});
